<section class="workspace">
  <div class="workspace-hero">
    <div class="workspace-icon">
      <i class="material-icons">{{ icon }}</i>
    </div>
    <div>
      <p class="eyebrow">{{ apiTag }} API</p>
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
    </div>
    <div class="workspace-actions">
      <button class="secondary-action" type="button" (click)="loadRows()">
        <i class="material-icons">refresh</i>
        <span>Refresh</span>
      </button>
      <button class="primary-action" type="button" *ngIf="isCrudView" (click)="startCreate()">
        <i class="material-icons">add</i>
        <span>Add {{ config.entityName }}</span>
      </button>
    </div>
  </div>

  <div class="alert error" *ngIf="errorMessage">
    <i class="material-icons">error</i>
    <span>{{ errorMessage }}</span>
  </div>
  <div class="alert success" *ngIf="successMessage">
    <i class="material-icons">check_circle</i>
    <span>{{ successMessage }}</span>
  </div>

  <div class="workspace-grid" *ngIf="isOperationsView">
    <article class="action-tile" *ngFor="let card of operationsCards">
      <i class="material-icons">{{ card.icon }}</i>
      <div>
        <h3>{{ card.label }}</h3>
        <strong>{{ card.value }}</strong>
        <p>{{ card.detail }}</p>
        <div class="metric-list" *ngIf="card.metrics.length">
          <span *ngFor="let metric of card.metrics">
            <small>{{ metric.label }}</small>
            <b>{{ metric.value }}</b>
          </span>
        </div>
        <div class="operations-feed" *ngIf="card.items?.length">
          <div class="feed-item" *ngFor="let item of card.items">
            <span>
              <strong>{{ item.title }}</strong>
              <small *ngIf="item.detail">{{ item.detail }}</small>
            </span>
            <em *ngIf="item.status">{{ item.status }}</em>
            <time *ngIf="item.time">{{ item.time }}</time>
          </div>
        </div>
      </div>
    </article>
  </div>

  <section class="notifications-panel" *ngIf="isOperationsView || isNotificationAuditView">
    <div class="notifications-header">
      <div>
        <p class="eyebrow">{{ isSystemLogsView ? 'System audit' : 'Operations feed' }}</p>
        <h3>{{ isSystemLogsView ? 'Notification deliveries' : 'Notifications' }}</h3>
        <p *ngIf="isSystemLogsView">Track queued email and message delivery outcomes recorded by the notification service.</p>
      </div>
      <span>{{ notificationRows.length }} shown</span>
    </div>

    <div class="notification-filters" *ngIf="isNotificationAuditView">
      <label>
        <span>Status</span>
        <select [(ngModel)]="notificationStatusFilter" (ngModelChange)="loadRows()">
          <option value="">All statuses</option>
          <option value="Pending">Pending</option>
          <option value="Queued">Queued</option>
          <option value="Sent">Sent</option>
          <option value="Failed">Failed</option>
        </select>
      </label>
      <label>
        <span>Channel</span>
        <select [(ngModel)]="notificationContactMethodFilter" (ngModelChange)="loadRows()">
          <option value="">All channels</option>
          <option value="Email">Email</option>
          <option value="SMS">SMS</option>
        </select>
      </label>
      <label>
        <span>Recent records</span>
        <select [(ngModel)]="notificationTake" (ngModelChange)="loadRows()">
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
          <option [ngValue]="250">250</option>
          <option [ngValue]="500">500</option>
        </select>
      </label>
      <button class="secondary-action" type="button" [disabled]="isLoading" (click)="loadRows()">
        <i class="material-icons">refresh</i>
        Refresh
      </button>
    </div>

    <div class="notifications-table" *ngIf="notificationRows.length; else noNotifications">
      <table>
        <thead>
          <tr>
            <th>Delivery</th>
            <th>Channel / recipient</th>
            <th>Status</th>
            <th>Message</th>
            <th>Failure Reason</th>
            <th>Queued</th>
            <th>Sent</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let notification of notificationRows">
            <td>
              <strong>{{ notification.title }}</strong>
              <small>{{ notification.type || 'Notification' }}<span *ngIf="notification.id"> · #{{ notification.id }}</span></small>
            </td>
            <td>
              <span>{{ notification.contactMethod || '-' }}</span>
              <small class="notification-contact">{{ notification.contactValue || '-' }}</small>
            </td>
            <td>
              <span
                class="notification-status"
                [class.sent]="notification.status.toLowerCase() === 'sent'"
                [class.failed]="notification.status.toLowerCase() === 'failed'"
                [class.pending]="notification.status.toLowerCase() === 'pending'"
                *ngIf="notification.status">{{ notification.status }}</span>
              <span *ngIf="!notification.status">-</span>
            </td>
            <td class="notification-detail">{{ notification.detail || '-' }}</td>
            <td class="notification-failure-reason">{{ notification.failureReason || '-' }}</td>
            <td>{{ notification.time || '-' }}</td>
            <td>{{ notification.sentAt || '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #noNotifications>
      <div class="empty-notifications">
        <i class="material-icons">notifications_off</i>
        <span>No notifications returned.</span>
      </div>
    </ng-template>
  </section>

  <section class="report-design-note" *ngIf="isReportsView">
    <i class="material-icons">event_note</i>
    <div>
      <p class="eyebrow">Future report placeholder</p>
      <h3>Evening operator booking report</h3>
      <p>Design note only: a scheduled evening report can summarize upcoming trips and booking counts for each operator. Real-time booking notifications are the active workflow for now.</p>
    </div>
  </section>

  <div class="data-panel" *ngIf="!isOperationsView && !isNotificationAuditView">
    <div class="data-toolbar">
      <div>
        <p class="eyebrow">{{ config.entityName }} records</p>
        <h3>{{ filteredRows.length }} shown</h3>
      </div>
      <input type="search" class="search-input" placeholder="Search records" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()">
    </div>

    <form class="workspace-form" *ngIf="showForm" [formGroup]="form" (ngSubmit)="saveRow()">
      <div class="form-header">
        <h3>{{ selectedRow ? 'Edit' : 'Add' }} {{ config.entityName }}</h3>
        <button class="btn-close" type="button" (click)="cancelForm()">x</button>
      </div>
      <div class="form-grid">
        <label *ngFor="let field of config.fields" [class.wide]="field.wide">
          {{ field.label }}
          <select *ngIf="field.type === 'select'" [formControlName]="field.key" class="form-control"
            [disabled]="isFieldDisabled(field)" (change)="field.key === 'primarySIMID' && onPrimarySIMChange()">
            <option *ngFor="let option of field.options || []" [ngValue]="option.value" [disabled]="isOptionDisabled(field, option)">{{ option.label }}</option>
          </select>
          <input *ngIf="field.type !== 'select'" [type]="field.type" [formControlName]="field.key" class="form-control">
        </label>
      </div>
      <div class="assignment-tools" *ngIf="apiTag === 'Device' && form.get('primarySIMID')?.value && form.get('secondarySIMID')?.value">
        <button class="btn btn-secondary" type="button" (click)="swapSIMs()">
          <i class="material-icons">swap_vert</i>
          Swap SIMs
        </button>
      </div>
      <div class="sim-confirmation" *ngIf="pendingSIMSave === 'confirm-removal'">
        <strong>Remove the selected SIM assignment?</strong>
        <span>The SIM will become available for another device.</span>
        <div class="form-actions">
          <button class="btn btn-secondary" type="button" (click)="cancelSIMSave()">Keep assignment</button>
          <button class="btn btn-danger" type="button" (click)="confirmSIMRemoval()">Remove and save</button>
        </div>
      </div>
      <div class="sim-confirmation" *ngIf="pendingSIMSave === 'resolve-primary'">
        <strong>A secondary SIM cannot remain without a primary SIM.</strong>
        <span>Promote the current secondary SIM to primary, or remove both assignments.</span>
        <div class="form-actions">
          <button class="btn btn-secondary" type="button" (click)="cancelSIMSave()">Cancel</button>
          <button class="btn btn-secondary" type="button" (click)="promoteSecondaryAndSave()">Promote secondary</button>
          <button class="btn btn-danger" type="button" (click)="removeBothAndSave()">Remove both</button>
        </div>
      </div>
      <div class="form-actions">
        <button class="btn btn-secondary" type="button" (click)="cancelForm()">Cancel</button>
        <button class="btn btn-primary" type="submit" [disabled]="form.invalid || isSaving">
          <i class="material-icons">save</i>
          {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
      </div>
    </form>

    <div class="table-responsive" *ngIf="filteredRows.length > 0">
      <table>
        <thead>
          <tr>
            <th *ngFor="let column of config.columns">{{ column.label }}</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredRows">
            <td *ngFor="let column of config.columns" [class.multiline-cell]="column.key === 'simSummary'">{{ getColumnValue(row, column.key) }}</td>
            <td class="actions-cell">
              <button class="btn-icon" type="button" (click)="editRow(row)" title="Edit">
                <i class="material-icons">edit</i>
              </button>
              <button class="btn-icon danger" type="button" *ngIf="isCrudView && apiTag !== 'Profile'" (click)="deleteRow(row)" title="Delete">
                <i class="material-icons">delete</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="empty-state" *ngIf="!isLoading && filteredRows.length === 0">
      <i class="material-icons">{{ icon }}</i>
      <h3>No records found</h3>
      <p>Use refresh or add a new {{ config.entityName.toLowerCase() }} record.</p>
    </div>

    <div class="loading-state" *ngIf="isLoading">
      <i class="material-icons">sync</i>
      <span>Loading {{ config.entityName.toLowerCase() }} data...</span>
    </div>
  </div>
</section>

<app-confirm-dialog
  *ngIf="rowPendingDelete"
  [title]="'Delete ' + config.entityName"
  [message]="'Delete this ' + config.entityName.toLowerCase() + '?'"
  confirmLabel="Delete"
  tone="danger"
  (confirmed)="confirmDeleteRow()"
  (cancelled)="cancelDeleteRow()">
</app-confirm-dialog>
